import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Terms = () => {
  const { language, t } = useLanguage();

  const content = language === 'en' ? (
    <div className="space-y-8 text-gray-600 leading-relaxed">
      <p>By accessing and using vacature.ai you agree to the following terms.</p>
      
      <section>
        <h2 className="text-xl font-bold text-brand-dark mb-4">Platform Purpose</h2>
        <p>Vacature.ai provides AI-powered tools designed to help users analyze professional profiles and discover potential career opportunities.</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-brand-dark mb-4">No Employment Guarantee</h2>
        <p>Vacature.ai does not guarantee job placement, employment offers, or recruitment outcomes.</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-brand-dark mb-4">AI Generated Insights</h2>
        <p>The platform uses artificial intelligence to analyze CV information and generate insights.</p>
        <p className="mt-4 font-medium">These insights are suggestions and should not be interpreted as professional career advice.</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-brand-dark mb-4">User Responsibility</h2>
        <p>Users are responsible for ensuring that the information provided is accurate and lawful.</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-brand-dark mb-4">Prohibited Use</h2>
        <p>Users may not misuse the platform, attempt to disrupt services, or upload unlawful content.</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-brand-dark mb-4">Limitation of Liability</h2>
        <p>Vacature.ai is provided on an "as available" basis without guarantees of uninterrupted service.</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-brand-dark mb-4">Changes</h2>
        <p>Vacature.ai reserves the right to modify these terms at any time.</p>
      </section>
    </div>
  ) : (
    <div className="space-y-8 text-gray-600 leading-relaxed">
      <p>Door vacature.ai te bezoeken en te gebruiken, gaat u akkoord met de volgende voorwaarden.</p>
      
      <section>
        <h2 className="text-xl font-bold text-brand-dark mb-4">Doel van het platform</h2>
        <p>Vacature.ai biedt AI-gestuurde tools die zijn ontworpen om gebruikers te helpen bij het analyseren van professionele profielen en het ontdekken van potentiële carrièremogelijkheden.</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-brand-dark mb-4">Geen garantie op werk</h2>
        <p>Vacature.ai garandeert geen plaatsing in een baan, werkaanbiedingen of wervingsresultaten.</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-brand-dark mb-4">AI-gegenereerde inzichten</h2>
        <p>Het platform maakt gebruik van kunstmatige intelligentie om CV-informatie te analyseren en inzichten te genereren.</p>
        <p className="mt-4 font-medium">Deze inzichten zijn suggesties en mogen niet worden geïnterpreteerd als professioneel loopbaanadvies.</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-brand-dark mb-4">Verantwoordelijkheid van de gebruiker</h2>
        <p>Gebruikers zijn verantwoordelijk voor het waarborgen dat de verstrekte informatie nauwkeurig en rechtmatig is.</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-brand-dark mb-4">Verboden gebruik</h2>
        <p>Gebruikers mogen het platform niet misbruiken, proberen de diensten te verstoren of onwettige inhoud uploaden.</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-brand-dark mb-4">Beperking van aansprakelijkheid</h2>
        <p>Vacature.ai wordt geleverd op een "as available" basis zonder garanties voor ononderbroken service.</p>
      </section>

      <section>
        <h2 className="text-xl font-bold text-brand-dark mb-4">Wijzigingen</h2>
        <p>Vacature.ai behoudt zich het recht voor om deze voorwaarden op elk moment te wijzigen.</p>
      </section>
    </div>
  );

  return (
    <div className="min-h-screen py-24 lg:py-32 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-5xl font-black text-brand-dark mb-16 italic uppercase tracking-tighter">
          {t.legal.termsTitle}
        </h1>
        <div className="bg-gray-50/50 p-12 lg:p-16 rounded-[3rem] border border-gray-100 shadow-sm">
          {content}
        </div>
      </div>
    </div>
  );
};

export default Terms;